import axios from 'axios';
import { ILog } from '../../../@types/modelV2/logging/loggingModels';

export default class LogHttpService {
    public static getList = async (fromDateUnix : number, toDateUnix : number, signal ?: AbortSignal) : Promise<Array<ILog>> => {
        const result = await axios.get(`${API_URL}/v1/Logging/GetList`, {
            params: {
                fromDateUnix,
                toDateUnix,
            },
            signal
        });

        return result.data;
    }
}
